var _path, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSabeqoonIconColored25(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.78 55.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.39,34.65l.12,19.84c1.87-1.35,8.17-5.15,21.4-5.99-.78-3.18-2.45-11.78,0-20.08-8.59.97-15.08,2.27-21.52,6.23",
    fill: "#702e8f",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.85,
    y: 34.91,
    width: 3.54,
    height: 19.58,
    fill: "#f2f2f2",
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.88,1.77c-4.99,0-9.05,4.06-9.05,9.05,0,1.43.32,2.8.96,4.07,1.54,3.07,4.63,4.99,8.08,4.99s6.55-1.91,8.1-4.99c.64-1.27.96-2.64.96-4.07,0-4.99-4.06-9.05-9.06-9.05M23.88,21.65c-4.12,0-7.83-2.28-9.67-5.96-.76-1.52-1.15-3.16-1.15-4.86C13.06,4.85,17.92,0,23.88,0s10.83,4.85,10.83,10.82c0,1.7-.39,3.34-1.15,4.86-1.85,3.68-5.56,5.96-9.68,5.96",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.62,32.35c-.15,0-.3-.04-.43-.11-.43-.24-.58-.78-.34-1.21l4-7.09c.24-.43.78-.58,1.21-.34.43.24.58.78.34,1.21l-4,7.09c-.16.29-.46.45-.77.45",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.12,32.23c-.31,0-.61-.16-.78-.46l-3.86-6.98c-.24-.43-.08-.97.35-1.2.43-.24.97-.08,1.2.35l3.86,6.97c.24.43.08.97-.35,1.2-.14.07-.28.11-.43.11",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14,40.82c-.49,0-.88-.39-.88-.88h0c0-.5.4-.89.88-.89s.88.4.88.88-.4.89-.88.89",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.66,28.33c-.31,0-.61-.16-.77-.44-.24-.43-.1-.97.33-1.21.09-.05.18-.11.26-.16.07-.05.15-.09.22-.14,2.15-1.31,4.22-2.25,6.32-2.86.47-.14.96.13,1.1.6.14.47-.13.96-.6,1.1-1.95.57-3.87,1.44-5.89,2.67l-.19.12c-.11.07-.22.14-.33.21-.14.08-.29.12-.44.12",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.63,40.63c-.49,0-.89-.39-.89-.88h0c0-.5.4-.89.89-.89s.88.4.88.88-.4.89-.88.89",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.32,28.42c-.16,0-.33-.05-.48-.14-.21-.13-.42-.27-.63-.39-2.01-1.23-3.92-2.1-5.85-2.66-.47-.14-.74-.63-.6-1.1.14-.47.63-.74,1.1-.6,2.08.61,4.13,1.54,6.27,2.85.22.14.45.28.67.42.41.26.53.81.26,1.22-.17.26-.45.41-.74.41",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7,47.83c-3.32.21-12.92,1.16-19.42,5.18v-17.81c0-.06,0-.11-.02-.16,6-4.28,16.15-5.31,19.52-5.54-1.91,9.63-.75,15.89-.09,18.34M22.98,53.85v-17.97c.5.14,1.02.16,1.53.07v17.98c-.51.11-1.03.09-1.53-.07M1.99,29.49c3.32.22,13.19,1.22,19.23,5.34v18.01c-6.49-3.88-15.86-4.81-19.14-5.01.67-2.45,1.82-8.71-.09-18.34M47.76,28.74c.06-.27-.01-.54-.18-.75-.17-.21-.43-.34-.71-.32-.59.02-14.57.47-22.15,6.32-.48.37-1.18.37-1.66,0C15.48,28.14,1.5,27.68.91,27.66c-.27-.02-.53.11-.71.32-.17.21-.24.49-.18.75,2.73,12.52.07,19.53.04,19.6-.11.27-.08.57.08.81.16.24.43.39.72.4.13,0,13.07.42,20.36,5.4.79.54,1.71.82,2.66.82s1.87-.28,2.66-.82c7.3-4.98,20.23-5.4,20.36-5.4.29,0,.55-.16.71-.4s.19-.54.08-.81c-.03-.07-2.7-7.02.04-19.6",
    fill: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.85,38.34c-.3,0-.59-.15-.75-.42-.26-.41-.13-.96.28-1.21.99-.62,7.89-2.75,9.95-2.86.49-.01.9.35.93.84.03.49-.35.91-.84.93-1.84.1-8.41,2.16-9.11,2.59-.14.09-.31.13-.46.13",
    fill: "#000",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSabeqoonIconColored25);
export default __webpack_public_path__ + "static/media/Sabeqoon_Icon_Colored_25.a98a3a2fde5469184c7867d71acb5893.svg";
export { ForwardRef as ReactComponent };